module.exports = "images/doc-currency-menu.92be8a5483c9fc790229a56cd39c6ef5.png";